import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrash = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 3.5H15M13 3.5V13.73C13 14.3641 12.3333 14.9983 11.6667 14.9983H4.33333C3.66667 14.9983 3 14.3641 3 13.73V3.5M5.75 3.5V1H10.25V3.5M6.25 5.75V12.75M9.75 5.75V12.75",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	})
});
export default SvgTrash;
